// services/mobileAppService.js
import api from './api';

/**
 * Сервис для работы с информацией о мобильном приложении
 */
const mobileAppService = {
  /**
   * Получение информации о мобильном приложении
   * @returns {Promise<Object>} - Информация о приложении (downloadUrl, version)
   */
  getMobileAppInfo: async () => {
    try {
      const response = await api.get('/mobile-app/info');
      return response.data;
    } catch (error) {
      console.error('Ошибка при получении информации о мобильном приложении:', error);
      throw error;
    }
  },

  /**
   * Обновление информации о мобильном приложении (только для админов)
   * @param {string} downloadUrl - Ссылка для скачивания приложения
   * @param {string} version - Версия приложения
   * @returns {Promise<Object>} - Обновленная информация о приложении
   */
  updateMobileAppInfo: async (downloadUrl, version) => {
    try {
      const response = await api.put('/mobile-app/info', {
        downloadUrl,
        version
      });
      return response.data;
    } catch (error) {
      console.error('Ошибка при обновлении информации о мобильном приложении:', error);
      throw error;
    }
  }
};

export default mobileAppService;

